import { useState } from 'react';
import './Register.css';

function Register() {
  const [domain, setDomain] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // For now, just show success message
    // In production, this would call the API
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    setSubmitted(true);
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="register-page">
        <div className="container">
          <div className="register-success card">
            <div className="success-icon">&#10003;</div>
            <h2>Registration Submitted!</h2>
            <p className="text-secondary">
              We've sent a verification email to <strong>{email}</strong>.
            </p>
            <p className="text-secondary mt-4">
              Once verified, we'll begin crawling <strong>{domain}</strong> for content
              with consent signals.
            </p>
            <div className="mt-8">
              <button 
                className="btn btn-secondary"
                onClick={() => {
                  setSubmitted(false);
                  setDomain('');
                  setEmail('');
                }}
              >
                Register Another Site
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="register-page">
      <div className="container">
        <div className="register-header">
          <h1>Register Your Site</h1>
          <p className="text-secondary">
            Opt-in to have your content indexed in the GoodFetch ethical AI archive.
          </p>
        </div>

        <div className="register-content">
          <div className="register-form-section card">
            <h3>Site Registration</h3>
            <form onSubmit={handleSubmit} className="register-form">
              <div className="form-group">
                <label htmlFor="domain">Domain</label>
                <input
                  type="text"
                  id="domain"
                  className="input"
                  placeholder="example.com"
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  required
                />
                <p className="form-hint text-secondary">
                  Enter your domain without https:// or trailing slashes
                </p>
              </div>

              <div className="form-group">
                <label htmlFor="email">Contact Email</label>
                <input
                  type="email"
                  id="email"
                  className="input"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <p className="form-hint text-secondary">
                  We'll send verification and updates to this email
                </p>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Submitting...' : 'Register Site'}
              </button>
            </form>
          </div>

          <div className="register-info card">
            <h3>Alternative: Use Content Signals</h3>
            <p className="text-secondary mb-4">
              You can also opt-in by adding Content Signals to your robots.txt file.
              This is the recommended approach for technical users.
            </p>
            
            <div className="code-block">
              <pre>
{`# Content Signals Policy
Content-Signal: search=yes, ai-train=yes

User-agent: GoodFetch
Allow: /`}
              </pre>
            </div>

            <p className="text-secondary mt-4">
              Learn more at{' '}
              <a href="https://contentsignals.org" target="_blank" rel="noopener noreferrer">
                contentsignals.org
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
